module.exports = __webpack_public_path__ + "static/media/renting-laser.68bdb5ed.md";